import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {

    constructor(private snackBar: MatSnackBar) { }

    _sharedDisplayInfo!: string;
    _sharedDisplayIcon!: string;
    _sharedDisplayIconColor!: string;
    _sharedDisplayBackgroundColor!: string;

    successSnackBar(message: string) {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            data: { heading: "Success", message: message, icon: 'check_circle_outline'},
            duration: 8000,
            panelClass: 'success-bar'
        });
    }

    errorSnackBar(message: string) {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            data: { heading: "Warning", message: message, icon: 'highlight_off'},
            duration: 8000,
            panelClass: 'warning-bar'
        });
    }
}
